document.addEventListener('toggle', (event) => {
  const opened = event.target;
  if (!(opened instanceof HTMLDetailsElement)) return;
  if (!opened.matches('[data-sfny-info-list] details')) return;
  if (!opened.open) return;

  const root = opened.closest('[data-sfny-info-list]');
  root.querySelectorAll('details[open]').forEach((item) => {
    if (item !== opened) item.open = false;
  });
}, true);

